module.exports = __webpack_public_path__ + "img/ucq.e4fd529.png";